const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/freebies/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import i18n from "@/lib/i18n";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { mobileFreebiesQuery } from "@/queries/mobile-freebies";
import { formSchema } from "@/stores/searchStore";
import { getGiveawaysStats } from "@/components/modules/giveaway-stats";
import { mergeFreebies } from "@/utils/merge-freebies";
export const Route = createFileRoute("/{-$locale}/freebies/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: search => formSchema.parse(search),
  beforeLoad: async () => {},
  loader: async ({
    context
  }) => {
    const {
      country,
      queryClient
    } = context;
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["giveaways-stats", {
        country
      }],
      queryFn: () => getGiveawaysStats({
        country: country ?? "US"
      }).catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["giveaways"],
      queryFn: () => httpClient.get<GiveawayOffer[]>("/free-games", {
        params: {
          country
        }
      }).then(mergeFreebies).catch(() => [])
    }), queryClient.prefetchQuery(mobileFreebiesQuery)]);
    const ogId = await httpClient.get<{
      id: string;
    }>("/free-games/og").catch(() => ({
      id: ""
    }));
    return {
      dehydratedState: dehydrate(queryClient),
      og: ogId.id
    };
  },
  head: ctx => {
    const {
      loaderData
    } = ctx;
    const ogImage = "https://cdn.egdata.app/cdn-cgi/imagedelivery/<ACCOUNT_HASH>/<IMAGE_ID>/<VARIANT_NAME>".replace("<ACCOUNT_HASH>", "RlN2EBAhhGSZh5aeUaPz3Q").replace("<IMAGE_ID>", String(loaderData?.og ?? "")).replace("<VARIANT_NAME>", "og");
    return {
      meta: [{
        title: i18n.t("freebies.meta.title")
      }, {
        name: "description",
        content: i18n.t("freebies.meta.description")
      }, {
        name: "og:title",
        content: i18n.t("freebies.meta.title")
      }, {
        name: "og:description",
        content: i18n.t("freebies.meta.description")
      }, {
        property: "twitter:title",
        content: i18n.t("freebies.meta.title")
      }, {
        property: "twitter:description",
        content: i18n.t("freebies.meta.description")
      }, {
        property: "og:image",
        content: ogImage
      }, {
        property: "og:image:alt",
        content: i18n.t("freebies.meta.title")
      }, {
        property: "og:type",
        content: "website"
      }, {
        property: "twitter:card",
        content: "summary_large_image"
      }, {
        property: "twitter:image",
        content: ogImage
      }]
    };
  }
});